import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { MegaMenu } from 'primereact/megamenu';
import { CascadeSelect } from 'primereact/cascadeselect';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

class LocaleDemo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCity: null,
      countries: [
        {
          name: 'México',
          code: 'MEX',
          lenguage: [
            {
              lname: 'Español',
              code: 'es-MX',
            },
          ],
        },
        {
          name: 'Canada',
          code: 'CA',
          lenguage: [
            {
              lname: 'Ingles',
              code: 'en-CA',
            },
            {
              lname: 'Frances',
              code: 'fr-CA',
            },
          ],
        },
        {
          name: 'Estados Unidos',
          code: 'US',
          lenguage: [
            {
              lname: 'Ingles',
              code: 'en-US',
            },
          ],
        },
        {
          name: 'Brasil',
          code: 'BR',
          lenguage: [
            {
              lname: 'Portuges',
              code: 'pt-BR',
            },
            {
              lname: 'Ingles',
              code: 'en-BRs',
            },
          ],
        },
      ],
    };
  }

  onChangeLenguage = async (e) => {
    const { i18n } = this.props;
    const { code } = e.value;
    const [language] = code.split('-');
    if (!i18n.hasResourceBundle(language, 'translation')) {
      // eslint-disable-next-line react/destructuring-assignment
      const response = await this.props[`getLocale${language.charAt(0).toUpperCase() + language.slice(1)}`]()
      await i18n.addResourceBundle(language, 'translation', response[0], true, true);
    }
    i18n.changeLanguage(language);
    this.setState({ selectedCity: e.value });
  };

  render() {
    const { t, i18n } = this.props;
    const { countries, selectedCity } = this.state;
    return (
      <div className="p-grid list-demo">
        <div className="p-col-12">
          <MegaMenu>
            <CascadeSelect
              value={selectedCity}
              options={countries}
              optionLabel="lname"
              optionGroupLabel="name"
              optionGroupChildren={['lenguage']}
              style={{ minWidth: '14rem' }}
              placeholder="Select a lenguage"
              onChange={this.onChangeLenguage}
            />
          </MegaMenu>
        </div>
        <div className="p-col-12">
          <div className="card">
            <h1 className="p-text-center">
              {t('Welcome')} - {i18n.language}
            </h1>
            <div className="p-fluid">
              <div className="p-field">
                <label htmlFor="firstname1">{t('formDemo.firstName')}</label>
                <InputText id="firstname1" type="text" />
              </div>
              <div className="p-field">
                <label htmlFor="lastname1">{t('formDemo.lasName')}</label>
                <InputText id="lastname1" type="text" />
              </div>
              <Button
                type="button"
                label={t('formDemo.btnSubmit')}
                className="p-mt-2"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(LocaleDemo);
